import { fromJS } from 'immutable';
import { Component } from 'react';
import AsyncData from 'conversations-async-data/async-data/AsyncData';
import { requestStarted } from 'conversations-async-data/async-data/operators/requestStarted';
import { requestFailed } from 'conversations-async-data/async-data/operators/requestFailed';
import { requestSucceededWithOperator } from 'conversations-async-data/async-data/operators/requestSucceededWithOperator';
import { getData } from 'conversations-async-data/async-data/operators/getters';
import { isLoading, isFailed, isSucceeded } from 'conversations-async-data/async-data/operators/statusComparators';
import { reportError } from 'conversations-error-reporting/error-reporting/reportError';
import I18n from 'I18n';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { Select } from 'foundations-components/transitional/components/Select';
import { H2 } from 'foundations-components/transitional/components/H2';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { fetchAdminUsers } from '../clients/fetchAdminUsers';
import { mapUsersToOptions } from '../../sales-users/operators/mapUsersToOptions';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class RequestAccessToInboxPrompt extends Component {
  constructor(props) {
    super(props);
    this.handleSetAdminToEmail = ({
      target: {
        value
      }
    }) => {
      this.setState({
        selectedAdminId: value
      });
    };
    this.sendEmail = () => {
      this.props.sendRequestAccessToInboxEmail({
        currentInboxId: this.props.currentInboxId,
        lastAccessedInboxId: this.props.lastAccessedInboxId,
        adminId: this.state.selectedAdminId
      });
      this.props.onConfirm();
    };
    this.state = {
      selectedAdminId: null,
      // @ts-expect-error ts-migrate(2348) FIXME: Value of type 'new <AsyncDataValue>(t?: Partial<As... Remove this comment to see the full error message
      asyncAdminUsers: AsyncData()
    };
  }
  componentDidMount() {
    this.setState(({
      asyncAdminUsers
    }) => ({
      asyncAdminUsers: requestStarted(asyncAdminUsers)
    }));
    fetchAdminUsers().then(adminUsersArray => {
      const adminUsers = fromJS(adminUsersArray);
      this.setState(({
        asyncAdminUsers
      }) => ({
        asyncAdminUsers: requestSucceededWithOperator(() => mapUsersToOptions(adminUsers), asyncAdminUsers)
      }));
    }).catch(error => {
      reportError({
        error,
        tags: {
          isVisibleToUser: true
        }
      });
      this.setState(({
        asyncAdminUsers
      }) => ({
        asyncAdminUsers: requestFailed(asyncAdminUsers)
      }));
    }).catch(err => {
      setTimeout(() => {
        throw err;
      });
    });
  }
  renderSelect() {
    const options = getData(this.state.asyncAdminUsers);
    return /*#__PURE__*/_jsx(Select, {
      marginBlockStart: "400",
      defaultValue: this.state.selectedAdminId
      // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
      ,
      options: options,
      onChange: evt => this.handleSetAdminToEmail(evt),
      placeholder: I18n.text('conversations-inbox-ui.requestAccessToInboxPrompt.placeholder')
    });
  }
  render() {
    return /*#__PURE__*/_jsxs(Modal, {
      children: [/*#__PURE__*/_jsx(DialogHeader, {
        children: /*#__PURE__*/_jsx(H2, {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "conversations-inbox-ui.requestAccessToInboxPrompt.title"
          })
        })
      }), /*#__PURE__*/_jsxs(DialogBody, {
        children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "conversations-inbox-ui.requestAccessToInboxPrompt.body"
        }), isLoading(this.state.asyncAdminUsers) && /*#__PURE__*/_jsx(LoadingSpinner, {}), isSucceeded(this.state.asyncAdminUsers) && this.renderSelect(), isFailed(this.state.asyncAdminUsers) && /*#__PURE__*/_jsxs(ErrorMessage, {
          children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "conversations-inbox-ui.fatalError.refreshThePage"
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "conversations-inbox-ui.fatalError.contactSupport"
          })]
        })]
      }), /*#__PURE__*/_jsxs(DialogFooter, {
        children: [/*#__PURE__*/_jsx(Button, {
          use: "primary",
          onClick: this.sendEmail,
          disabled: this.state.selectedAdminId === null,
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "conversations-inbox-ui.requestAccessToInboxPrompt.confirm"
          })
        }), /*#__PURE__*/_jsx(Button, {
          use: "secondary",
          onClick: this.props.onReject,
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "conversations-inbox-ui.requestAccessToInboxPrompt.cancel"
          })
        })]
      })]
    });
  }
}
RequestAccessToInboxPrompt.displayName = 'RequestAccessToInboxPrompt';